import { createSlice } from '@reduxjs/toolkit';
import realtimeService from '../services/realtimeService';

const realtimeSlice = createSlice({
  name: 'realtime',
  initialState: {
    collections: {},
  },
  reducers: {
    setData: (state, action) => {
      const { collection, data } = action.payload;
      state.collections[collection] = data;
    },
  },
});

export const { setData } = realtimeSlice.actions;

export const listenToCollection = (listenerKey, collectionName, queryParams) => (dispatch) => {
  // Assuming realtimeService is available
  realtimeService.listenToCollection(
    listenerKey,
    collectionName,
    queryParams,
    (data) => {
      dispatch(setData({ collection: listenerKey, data }));
    },
    (error) => {
      console.error(error);
    }
  );
};

export default realtimeSlice.reducer;
